import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterOutById',
})
export class FilterOutByIdPipe implements PipeTransform {
  transform<T extends { [key: string]: any }>(
    items: T[] | null | undefined,
    idToExclude: any,
    key: string = '_id',
  ): T[] {
    if (!items) {
      return [];
    }
    if (idToExclude === undefined || idToExclude === null) {
      return items;
    }
    return items.filter((item) => item[key] !== idToExclude);
  }
}
